import { useEffect, useState } from "react";
import { api } from "./api";

// Live market stats (price, market cap/FDV, 24h change, volume) for a set of tokens — real GeckoTerminal data, never fabricated.
export const useMarketSummary = (addresses) => {
  const key = [...new Set(addresses.filter(Boolean).map((a) => a.toLowerCase()))].sort().join(",");
  const [d, setD] = useState({});
  useEffect(() => {
    if (!key) return;
    let live = true;
    const load = () => api.get("/market/summary", { params: { addresses: key } }).then((r) => live && setD(r.data.tokens)).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    return () => { live = false; clearInterval(t); };
  }, [key]);
  return d;
};

export const changeTone = (v) => (v == null ? "text-slate-500" : v >= 0 ? "text-lime" : "text-red-400");
